var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0768 15.6204C48.0395 15.6204 44.7666 12.3475 44.7666 8.31018C44.7666 4.27288 48.0395 1 52.0768 1C56.1141 1 59.387 4.27288 59.387 8.31018C59.387 12.3475 56.1141 15.6204 52.0768 15.6204Z",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4936 17.2347C7.45255 17.2347 4.98727 14.7694 4.98727 11.7283C4.98727 8.68721 7.45255 6.22192 10.4936 6.22192C13.5347 6.22192 16 8.68721 16 11.7283C16 14.7694 13.5347 17.2347 10.4936 17.2347Z",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45661 61.0001C3.89121 61.0001 1.00088 58.1098 1.00088 54.5444C1.00088 50.979 3.89121 48.0886 7.45661 48.0886C11.022 48.0886 13.9124 50.979 13.9124 54.5444C13.9124 58.1098 11.022 61.0001 7.45661 61.0001Z",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6466 61C48.6093 61 45.3364 57.7271 45.3364 53.6898C45.3364 49.6525 48.6093 46.3796 52.6466 46.3796C56.6839 46.3796 59.9568 49.6525 59.9568 53.6898C59.9568 57.7271 56.6839 61 52.6466 61Z",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2412 30.811L12.1082 48.9441",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8176 15.1462L47.8052 49.1338",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2406 41.5376C24.3157 41.5376 19.5127 36.7346 19.5127 30.8097C19.5127 24.8848 24.3157 20.0818 30.2406 20.0818C36.1655 20.0818 40.9685 24.8848 40.9685 30.8097C40.9685 36.7346 36.1655 41.5376 30.2406 41.5376Z",
    fill: "#845EC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.06c7a82d1c1f8cde4b96ee3769445f83.svg";
export { ForwardRef as ReactComponent };